import React from 'react';
import { createConsumer } from '@rails/actioncable';

export const createCableConsumer = (params) => {
	if (!params) return null;

	const { cableUrl } = params;
	return createConsumer(cableUrl);
};
